module.exports = __webpack_public_path__ + "VIP Racing Logo Long Scaled.png?d62673bb5295afba47d4a65d7f602453";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/VIP Racing Logo Long Scaled.png
// module id = 11
// module chunks = 0